import React from 'react';
import styled from 'styled-components';

import HeaderTitle from './HeaderTitle';

const transition: string = '0.5s cubic-bezier(0.075, 0.82, 0.165, 1)';

const StyledHeaderTitle = styled(HeaderTitle)`
  &.editable {
    .title {
      cursor: pointer;
      border-radius: 4px;
      transition: padding ${transition}, margin-right ${transition},
        background-color ${transition};
      &:hover {
        padding: 0 4px;
        margin-right: -8px;
        background-color: rgba(0, 0, 0, 0.12);
      }
    }
  }
`;

export interface HeaderTitleEditProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const HeaderTitleEdit: React.FC<HeaderTitleEditProps> = (
  props: HeaderTitleEditProps
) => {
  const {
    children,
    className: classNameProp = '',
    disabled = false,
    onClick
  } = props;
  const className: string = `${classNameProp} ${!disabled ? 'editable' : ''}`;
  return (
    <StyledHeaderTitle
      children={children}
      className={className}
      onClick={event => {
        if (!disabled) {
          onClick?.(event);
        }
      }}
    />
  );
};

export default HeaderTitleEdit;
